import IdColumn from './IdColumn';
import TitleColumn from './TitleColumn';
import StatusColumn from './StatusColumn';
import PreviewColumn from "./PreviewColumn";
import PriceColumn from "./PriceColumn";
import SkuColumn from "./SkuColumn";
import SalePriceColumn from "./SalePriceColumn";
import BrandColumn from "./BrandColumn";
import CategoryColumn from "./CategoryColumn";
import ImageColumn from "./ImageColumn";
import AvailabilityColumn from "./AvailabilityColumn";
import MpnColumn from "./MpnColumn";
import GtinColumn from "./GtinColumn";
import WeightColumn from "./WeightColumn";
import GenderColumn from "./GenderColumn";
import SizeColumn from "./SizeColumn";
import MaterialColumn from "./MaterialColumn";
import IdentifierExistsColumn from "./IdentifierExistsColumn";
import ColorColumn from "./ColorColumn";
import ConditionColumn from "./ConditionColumn";
import ShippingColumn from "./ShippingColumn";
import TypeColumn from "./TypeColumn";
import ItemGroupIdColumn from "./ItemGroupIdColumn";
import CreatedOnColumn from "./CreatedOnColumn";
import UpdatedOnColumn from "./UpdatedOnColumn";
import UrlColumn from "./UrlColumn";
import PropertiesColumn from "./PropertiesColumn";

// Column renderer factory
const createProductColumnRenderers = () => {
  const renderers = {
    'image': (props) => <ImageColumn {...props} />,
    'title': (props) => <TitleColumn {...props} />,
    'status': (props) => <StatusColumn {...props} />,
    'sku': (props) => <SkuColumn {...props} />,
    'price': (props) => <PriceColumn {...props} />,
    'sale_price': (props) => <SalePriceColumn {...props} />,
    'brand': (props) => <BrandColumn {...props} />,
    'category': (props) => <CategoryColumn {...props} />,
    'id': (props) => <IdColumn {...props} />,
    'preview': (props) => <PreviewColumn {...props} />,
    'availability': (props) => <AvailabilityColumn {...props} />,
    'gtin': (props) => <GtinColumn {...props}/>,
    'mpn': (props) => <MpnColumn {...props}/>,
    'weight': (props) => <WeightColumn {...props}/>,
    'gender': (props) => <GenderColumn {...props}/>,
    'size': (props) => <SizeColumn {...props}/>,
    'material': (props) => <MaterialColumn {...props}/>,
    'identifier_exists': (props) => <IdentifierExistsColumn {...props}/>,
    'color': (props) => <ColorColumn {...props}/>,
    'condition': (props) => <ConditionColumn {...props}/>,
    'shipping': (props) => <ShippingColumn {...props}/>,
    'type': (props) => <TypeColumn {...props}/>,
    'item_group_id': (props) => <ItemGroupIdColumn {...props}/>,
    'created': (props) => <CreatedOnColumn {...props}/>,
    'updated': (props) => <UpdatedOnColumn {...props}/>,
    'url': (props) => <UrlColumn {...props}/>,
  };

  // Handle custom properties with a special prefix
  return new Proxy(renderers, {
    get: (target, prop) => {
      // Check if the column ID is a custom property (prefixed with 'custom_')
      if (typeof prop === 'string' && prop.startsWith('custom_')) {
        const propertyName = prop.replace('custom_', '');
        return (props) => <PropertiesColumn {...props} propertyName={propertyName}/>;
      }
      return target[prop];
    }
  });
};

export {
  IdColumn,
  TitleColumn,
  PreviewColumn,
  StatusColumn,
  PriceColumn,
  SkuColumn,
  SalePriceColumn,
  BrandColumn,
  CategoryColumn,
  ImageColumn,
  AvailabilityColumn,
  MpnColumn,
  GtinColumn,
  WeightColumn,
  GenderColumn,
  SizeColumn,
  MaterialColumn,
  IdentifierExistsColumn,
  ColorColumn,
  ConditionColumn,
  ShippingColumn,
  TypeColumn,
  ItemGroupIdColumn,
  CreatedOnColumn,
  UpdatedOnColumn,
  PropertiesColumn,
  createProductColumnRenderers
};
